import React from 'react';

import { SubHeading } from '../../components/SubHeading/SubHeading';
import './Header.css';
import { pickup, safari, ticket, vacation } from '../../constants/images';

export const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="DGA Tours And Travel" />
      <h1 className="app__header-h1">Tour and Travel Hassle-Free</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}> To dare is to do. Take the tour you have always wanted to with the best that there is: Das Grosse Abenteuer Tours and Travel, Kenya. For Tour Packages, Transportation, Tour guiding, Day adventures and hikes, and more...</p>
      <button type="button" className="custom__button"><a href='packages'>Explore Safaris and Tours</a></button>
    </div>

    <div className="app__wrapper_img">
      <img src={safari} alt="header_img" />
    </div>
  </div>
);


export const Header2 = () => (
  <div className="app__bg app__wrapper section__padding" id="home">
    <div className="app__wrapper_img">
      <img src={ticket} alt="header_img" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="DGA Ticket-Booking" />
      <h1 className="app__header-h1">Let us plan the journey for you</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}> We will book the desired tickets for you, to go anywhere around the world; keep reminding you of your journey to the last minute. Book Flight and Train tickets with us today, and enjoy great discounts as you travel</p>
      <button type="button" className="custom__button"><a href='tickets'>Request for Tickets</a></button>
    </div>
  </div>
)


export const Header3 = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="DGA Transfers" />
      <h1 className="app__header-h1">Stuck? We'll pick you up</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}> Airport, train and bus stations pick up and transfer services available. Enjoy the rides to parks, or be dropped to your house by DGA Transfers service, to your comfort.</p>
      <button type="button" className="custom__button"><a href='transfers'>Request for Transport</a></button>
    </div>
    <div className="app__wrapper_img">
      <img src={pickup} alt="header_img" />
    </div>
  </div>
)

export const Header4 = () => (
  <div className="app__bg app__wrapper section__padding" id="home">
    <div className="app__wrapper_img">
      <img src={vacation} alt="header_img" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="DGA Vacations" />
      <h1 className="app__header-h1">We plan, You Attend</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}> We Are available to plan with you your vacation and staycations, foreign and domestic trips. We plan the trip, catering for all logistics, bookings, and other trip requirements, until you return back to your home safe. What's required for you? - Just attend. </p>
      <button type="button" className="custom__button">Request for Vacation Planning</button>
    </div>
  </div>
)
// export default Header;
